if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();

        if($('.item_key').length && $('.edit_url').length) {
          let item_key = window.generateTimestampedUUID()
          $('.item_key').val(item_key);
          $('.edit_url').val(window.getEditUrl(item_key))
        }

        if($('.support_item_key').length && $('.support_edit_url').length) {
          let item_key = window.generateTimestampedUUID()
          $('.support_item_key').val(item_key);
          $('.support_edit_url').val(window.getEditUrl(item_key))
        }

        if(!this.querySelector('form').checkValidity()) {
          let input_selectors = ['.bp-name-input', '.bp-weight-input', '.bp-pounds-input', '.bp-ounces-input'];
          for (var index in input_selectors) {
            let selector = input_selectors[index];
            if (this.handleBirthPosterInputs(selector))
            return
          }
        }

        let time = $('#birth-time').val();
        if(time && time.includes(':')) {
          let time_arr = time.split(":");
          if(!(time_arr[0].length > 0 && time_arr[1].length > 0)) {
            $('#birth-time').val('');
            $('#bp-hours').val('');
            $('#bp-minutes').val('');
            $('#birth-time').change();
          }
        }

        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        if(typeof edit_cart !== 'undefined' && edit_cart === true) {
          let change_obj = {};
          change_obj["id"] = edit_key;
          change_obj["quantity"] = edit_qt;
          await fetch(window.Shopify.routes.root + 'cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(change_obj)
          });
          edit_cart = false;
          edit_key = '';
          $('.bp-buy-btn .product-form__submit span').text(window.variantStrings.addToCart);
        }

        if(typeof no_of_babies !== 'undefined') {
          if(no_of_babies < 3) {
            if($('#bp-heading-value1').length) {
              let items = $('.birthposter-template .bp-poster-headline > *');
              let headline = '';

              items.each(function(i, item){
                var attr = $(item).attr('data-input');
                var index = $(item).attr('data-index');
                //PLACING THIS WORKAROUND FOR MISSING NAME.
                if(typeof attr !== 'undefined' && attr !== false) {
                  let val = $(`${$(item).attr("data-input")}`).val().trim();
                  if(index == "2") {
                    headline += ' &';
                  }
                  headline += ' ';
                  headline += val;
                }
                else if($(item).css("display") !== "none") {
                  headline += ' '
                  headline += $(item).text().trim();
                }
              });

              // headline = ($('.birthposter-template .bp-scale-text:not([style*="display: none"]').text() + ' ' +  $('.birthposter-template .bp-birth-name').text()).trim(); 
              $('#bp-heading-value1').val(headline.trim());
            }
          }
          else {
            for(var i=1; i <= no_of_babies; i++) {
              if($(`#bp-heading-value${i}`).length) {
                let items = $(`.birthposter-template .bp-poster-info[data-index="${i}"] .bp-poster-headline > *`);
                let headline = '';

                items.each(function(i, item){
                  var attr = $(item).attr('data-input');
                  if(typeof attr !== 'undefined' && attr !== false) {
                    let val = $(`${$(item).attr("data-input")}`).val().trim();
                    headline += ' '
                    headline += val;
                  }
                  else if($(item).css("display") !== "none") {
                    headline += ' '
                    headline += $(item).text().trim();
                  }
                });

                // headline = ($(`.birthposter-template .bp-poster-info[data-index="${i}"] .bp-scale-text:not([style*="display: none"])`).text() + ' ' +  $(`.birthposter-template .bp-poster-info[data-index="${i}"] .bp-birth-name`).text()).trim(); 
                $(`#bp-heading-value${i}`).val(headline.trim());
              }
            }
          }
          for(var i=1; i <= no_of_babies; i++) {
            if($(`#bp-subheading-value${i}`).length) {
              let length = ($(`#length-current-${i}`).length) ? $(`#length-current-${i}`).val() : $(`.birthposter-template .bp-length[data-index="${i}"]`).text();
              let metric_weight = ($(`#weight-metric-current-${i}`).length) ? $(`#weight-metric-current-${i}`).val() : $(`.birthposter-template .bp-weight[data-index="${i}"] .metric-weight:not([style*="display: none"])`).text();
              let imperial = ($(`#weight-imperial-current-${i}`).length) ? $(`#weight-imperial-current-${i}`).val() : $(`.birthposter-template .bp-weight[data-index="${i}"] .imperial-weight:not([style*="display: none"])`).text();
              let date = ($(`#date-current-${i}`).length) ? $(`#date-current-${i}`).val() : $(`.birthposter-template .bp-date[data-index="${i}"]`).text();
              let time = ($(`#time-current-${i}`).length) ? $(`#time-current-${i}`).val() : $(`.birthposter-template .bp-time[data-index="${i}"]`).text();
              let place = ($(`#place-current-${i}`).length) ? $(`#place-current-${i}`).val() : $(`.birthposter-template .bp-place[data-index="${i}"]`).text();
              
              let subheading = [length, metric_weight, imperial,
                [date, time].filter(str => str !== "").join(' '),
                place
              ].filter(str => str !== "").join(' / ').trim();
              $(`#bp-subheading-value${i}`).val(subheading);

              $(`#bp-check-info${i}`).val(`${length} ## ${metric_weight} ## ${imperial} ## ${date} ## ${time} ## ${place}`);
            }
          }
        }

        if(typeof is_starposter !== 'undefined') {
          let headline = ($('.birthposter-template .bp-stars-text1:not([style*="display: none"]').text() + ' ' +  $('.birthposter-template .bp-stars-text2').text()).trim(); 
          $('#bp-heading-value').val(headline);
          let subheading = [$(`.birthposter-template .bp-plats-text`).text(),
                            [$(`.birthposter-template .bp-date`).text(),$(`.birthposter-template .bp-time`).text()].filter(str => str !== "").join(' '),
                            $(`.birthposter-template .bp-extra-text`).text()].filter(str => str !== "").join(' / ').trim();
          $(`#bp-subheading-value`).val(subheading);

          let original_canvas = $('.birthposter-template .star-render canvas');
          let starmap_canvas = $('.birthposter-template .star-render canvas').clone();

          starmap_canvas[0].getContext('2d').drawImage(original_canvas[0],0,0)
          $(".hidden-preview .star-render").append(starmap_canvas);
        }

        if(typeof is_starposter_alfredssons !== 'undefined') {
          let subheading = [$(`.birthposter-template .bp-plats-text`).text(),
                            [$(`.birthposter-template .bp-date`).text(),$(`.birthposter-template .bp-time`).text()].filter(str => str !== "").join(' '),
                            $(`.birthposter-template .bp-extra-text`).text()].filter(str => str !== "").join(' / ').trim();
          $(`#bp-subheading-value`).val(subheading);

          let original_canvas = $('.birthposter-template .star-render canvas');
          let starmap_canvas = $('.birthposter-template .star-render canvas').clone();

          starmap_canvas[0].getContext('2d').drawImage(original_canvas[0],0,0);
          $(".hidden-preview .star-render").empty();
          $(".hidden-preview .star-render").append(starmap_canvas);

          if(!(typeof svg_changed !== 'undefined' && svg_changed == false)) {
            if(Celestial && (typeof Celestial.uploadSVG != "undefined")) {
              let svg_url = await Celestial.uploadSVG();
              $(`#bp-starmap-svg`).val(svg_url);
            }
          }
          else {
            if(typeof curr_svg_url !== 'undefined' && curr_svg_url != '') {
              $(`#bp-starmap-svg`).val(curr_svg_url);
            }
          }
        }

        let url_element = $('.bp-url');
        if(url_element.length){
          let myform = $(this.form);
          url_element.val(this.makeURL(myform));
        }

        if(typeof edit_item !== 'undefined' && edit_item === true) {
          let myform = $(this.form);
          let api_form_filters = ['__viewbox', '__template', '__baby_count', '__item_key', '__edit_url', '__edit_email_language', 'check_info'];
          let key_map = {
            "background": "background_color",
            "color_": "illustration_color_",
            "[__color]": "background_color",
            "[__url]": "data_url",
            "direction_": "orientation_",
            "height_": "length_",
            "show_constellation": "constellation",
            "[rad1]": "row1_1",
            "[rad2]": "row2_1",
            "[rad1_prefix]": "row_prefix",
            "source_url": "svg",
            "intensity": "filter_intensity",
            "[row1]": "row1_1",
            "[row2]": "row2_1",
            "textColor": "text_color",
            "session": "photo_session",
            "text1": "row1_1",
            "text2": "row2_1",
            "[__orientation]": "poster_orientation"
          };
          let formData = myform.serializeArray();
          if(typeof no_of_babies !== 'undefined' || typeof is_letterposter !== 'undefined' ) {
            formData = this.autoContrastTweakSerializedArray(formData);
          }
          formData = formData.filter(item => (item.name.includes('properties')));
          formData = formData.map((item) => {
            if(item.name.includes('template') && item.value == "starmap-classic") {
              return { "name": "layout", "value": "classic" };
            }
            if(item.name.includes('template') && item.value == "starmap-fill") {
              return { "name": "layout", "value": "infinite" };
            }
            return item;
          })
          formData = formData.filter(item => !api_form_filters.some(filter => item.name.includes(filter))); 
          formData = formData.map(item => { 
            let key_map_keys = Object.keys(key_map);
            let filtered_key = key_map_keys.filter((key) => item.name.includes(key))
            if (filtered_key.length) {
              filtered_key.forEach((key) => {
                item.name = item.name.replaceAll(key, key_map[key])
              })
            }
            item.name = item.name.replaceAll('properties', '').replaceAll('[', '').replaceAll(']', '').replaceAll('__', '');
            return item;
          });

          let body = { };
          let non_empty_keys = ["illustration", "orientation", "background_color", "illustration_color", 
            "length", "data_url", "constellation", "svg", "layout", "filter", "filter_intensity", "text_color", 
            "photo_session", "letter"];

          formData.forEach((item) => {
            let key_in_restriction = non_empty_keys.some((key) => item.name.includes(key))
            if(!(key_in_restriction && item.value == "")) {
              if(item.name.includes("orientation")) {
                body[item.name] = item.value.toLowerCase();
              }
              else if(item.name.includes("filter") && item.value == "original") {
                body[item.name] = item.value;
                body["filter_intensity"] = "100";
              }
              else {
                body[item.name] = item.value;
              }
            }
          })
            
          let auth_key = '0LlHH9jBVy8qk4oqPSKCucIbEfnmmaiWUM3UzoccecUE5zCZmX7FDYFa7R8UKWmX';
          let headers = {
              'Content-Type': 'application/json',
              'X-API-Key': auth_key
          };
          let api_url = `https://dashboard.birthbox.se/api/v1/shopify`;
          let order_item_endpoint = api_url + `/order-item/${item_key}`;

          let response = await fetch(order_item_endpoint, {
              method: 'POST',
              headers: headers,
              body: JSON.stringify(body)
          });
          response = await response.json();

          if(response.result == "updated") {
            this.submitButton.classList.remove('loading');
            this.querySelector('.loading__spinner').classList.add('hidden');
            const submitButtonText = this.submitButton.querySelector('[name="add"] > span');
            if(submitButtonText) {
              submitButtonText.textContent = window.variantStrings.changesSaved;
            }
            if((typeof changes_made !== 'undefined')) {
              changes_made = false;
            }

            var klaviyo = window.klaviyo || [];

            let email = response.data.customer_email;
            let data_url = response.data.data_url
            let preview = (data_url.includes('?')) ? data_url + "&view=birthposter_preview" : data_url + "?view=birthposter_preview";
            let edit_url = response.data.edit_url;
            let edit_lang = response.data.edit_email_language

            if(response.data.update_type == "customer") {
              klaviyo.identify({ '$email': email}, function() {
                  klaviyo.identify({ 'preview': preview, 'edit_url': edit_url, 'country_code': edit_lang}, function() {   
                      klaviyo.track('Order Edited') 
                  })
              })
            }
            return;
          }

          // var url_visit = new URL(window.location.href);
          // url_visit.searchParams.delete("item_key");
          // location.href = url_visit.href;

          this.submitButton.classList.remove('loading');
          this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading__spinner').classList.add('hidden');
          return;
        }

        let preview_element = $('.bp-preview-url');
        if(preview_element.length){
          let preview_img = document.querySelector(".hidden-preview .bp-poster-preview .bp-illustration-img");
          try {
            if(preview_img) {
              await this.imageLoaded(preview_img);
            }
            let file = await this.takeScreenshot()
            if(file) {
              let dataTransfer = new DataTransfer();
              dataTransfer.items.add(file);
              preview_element[0].files = dataTransfer.files;
            }
          } catch (error) {
              preview_element[0].value = ''
              console.error(error);
          }
        }

        var formData = new FormData(this.form);
        if(typeof no_of_babies !== 'undefined' || typeof is_letterposter !== 'undefined') {
          formData = this.autoContrastTweak(formData);
        }

        const frame_selector = $(`[name="frame-selector"]:checked`);
        if (frame_selector.length && frame_selector.val() != "no_frame"){
          var pd_obj = {};
          for (const p of formData.entries()){ 
            pd_obj[p[0]] = p[1]
          }
          formData = new FormData();
          var frame_obj = { 'id': frame_selector.val(), 'quantity': pd_obj.quantity }
          var items = [frame_obj, pd_obj];
          items.forEach((obj, index) => {
            Object.entries(obj).forEach(([key, value]) => {
              formData.append(`items[${index}][${key}]`, value);
            });
          });
        }

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleBirthPosterInputs(selector) {
        let input_fields = document.querySelectorAll(selector);
        if(input_fields) {
          for (let i=0; i < input_fields.length; i++) {
            let input_field = input_fields[i];
            if(input_field && !input_field.checkValidity()) {
              input_field.closest('.bp-sidebar-item').querySelector('.bp-sidebar-item-radio').labels[0].click();
              input_field.classList.add('bp-input-error');
              return true;
            }
          }
        }
        return false;
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      makeURL(form) {
        let formData = form.serializeArray();
        formData = formData.filter(item => (item.value != '' || by_default_valued_properties.some(prop => item.name.includes(prop))));
        formData = formData.filter(item => (item.name.includes('properties') || item.name.includes('prop') || item.name.includes('frame-selector')))
        formData = formData.filter(item => !form_filters.some(filter => item.name.includes(filter)))

        const jsonString = JSON.stringify(formData);
        let sp_encoded_string = window.myVerifiedEncoding(jsonString)
        const encoded_string = encodeURIComponent(sp_encoded_string);

        var url_visit = new URL(window.location.href);
        url_visit.searchParams.delete("item_key");
        url_visit.searchParams.append("values", encoded_string);
        return url_visit.href
      }

      autoContrastTweak(formData) {
        if(typeof is_letterposter !== 'undefined') {
          let bg_color = formData.get('properties[__color]');
          let clr = formData.get(`properties[__letter_color]`);
          if(
            clr == "black"
            && bg_color == "black"
          ) {
            formData.set(`properties[__letter_color]`, "white");
          }
        }
        else {
          let bg_color = formData.get('properties[__background]');
          for(var i=1; i <= no_of_babies; i++) {
            let clr = formData.get(`properties[__color_${i}]`);
            let illustration = $(`.bp-variant-options-radio[data-index="${i}"]:checked`).attr('data-value');
            let illustration_swatches = $(`.bp-illustration-block[data-index="${i}"] .bp-swatch-container`);
  
            if(illustration_swatches.length < 2
              && !illustration.includes("aquarelle")
              && clr == "black"
              && bg_color == "black"
            ) {
              formData.set(`properties[__color_${i}]`, "white");
            }
          }
        }
        return formData
      }

      autoContrastTweakSerializedArray(formData) {
        if(typeof is_letterposter !== 'undefined') {
          let bg_color = formData.find((item) => {
            return item.name == 'properties[__color]';
          }).value
          let clr = formData.find((item) => {
            return item.name == `properties[__letter_color]`;
          }).value

          if(
            clr == "black"
            && bg_color == "black"
          ) {
            formData.map(item => { 
              if(item.name == `properties[__letter_color]`){
                item.value = "white"
              }
              return item
            });
          }
        }
        else {
          let bg_color = formData.find((item) => {
            return item.name == 'properties[__background]';
          }).value
          for(var i=1; i <= no_of_babies; i++) {
            let clr = formData.find((item) => {
              return item.name == `properties[__color_${i}]`;
            }).value
            let illustration = $(`.bp-variant-options-radio[data-index="${i}"]:checked`).attr('data-value');
            let illustration_swatches = $(`.bp-illustration-block[data-index="${i}"] .bp-swatch-container`);
  
            if(illustration_swatches.length < 2
              && !illustration.includes("aquarelle")
              && clr == "black"
              && bg_color == "black"
            ) {
              formData.map(item => { 
                if(item.name == `properties[__color_${i}]`){
                  item.value = "white"
                }
                return item
              });
            }
          }
        }
        return formData
      }

      takeScreenshot(){
        $('.bp-viewbox').val('');
        
        // function svgDataUrlToBlob(svgDataUrl, callback) {
        //   const link = document.createElement("a");
        //   link.href = svgDataUrl;
        //   link.download = "image.svg"; // Name of the file to download
        //   document.body.appendChild(link);
        //   link.click();

        //   const img = new Image();
        //   img.crossOrigin = "anonymous";
        //   img.src = svgDataUrl;

        //   img.onload = () => {
        //     const canvas = document.createElement("canvas");
        //     canvas.width = img.width;
        //     canvas.height = img.height;
        
        //     const ctx = canvas.getContext("2d");
        //     ctx.drawImage(img, 0, 0);
        
        //     canvas.toBlob((blob) => {
        //       callback(blob);
        //     }, "image/jpg");
        //   };

        //   img.onerror = () => {
        //     console.error("Failed to load SVG data URL into image.");
        //     callback(null);
        //   };
        // }

        function svgDataUrlToDirectBlob(svgDataUrl) {
          // return new Promise((resolve, reject) => {
          //   const svgContent = svgDataUrl.replace(/^data:image\/svg\+xml;charset=utf-8,/, '').replace(/<svg([^>]+)width="(\d+)" height="(\d+)"/, 
          //     (match, p1, width, height) => {
          //         return `<svg${p1} viewBox="0 0 ${width} ${height}" width="100%" height="100%"`;
          //   });
          //   let base64content = btoa(unescape(encodeURIComponent(unescape(svgContent))))
          //   const newSvgDataUrl = 'data:image/svg+xml;base64,' + base64content;

          //   let preview_element = $(".hidden-preview");
          //   preview_element.empty();
          //   preview_element.html(unescape(svgContent));

          //   // const svgEl = document.querySelector(".hidden-preview svg");
          //   // let svgBB = svgEl.getBBox();
          //   // let svgW = svgBB.width;
          //   // let svgH = svgBB.height;

          //   // let blob = new Blob([unescape(svgContent)], {type: 'image/svg+xml'});
          //   // let URL = window.URL;
          //   // let blobURL = URL.createObjectURL(blob);

          //   const img = new Image();
          //   img.crossOrigin = 'Anonymous';

          //   img.onload = () => {
          //     const canvas = document.createElement('canvas');
          //     canvas.width = img.width;
          //     canvas.height = img.height;

          //     const ctx = canvas.getContext('2d');
          //     // setTimeout(function () {
          //       ctx.drawImage(img, 0, 0);

          //       canvas.toBlob((blob) => {
          //         resolve(blob);
          //       });
          //     // }, 300);
          //   };

          //   // Handle image loading errors
          //   img.onerror = (e) => {
          //     reject('');
          //   };

          //   img.src = newSvgDataUrl;
          // });

          const svgContent = svgDataUrl.replace(/^data:image\/svg\+xml;charset=utf-8,/, '')
          .replace(/<svg([^>]+)width="(\d+)" height="(\d+)"/, 
            (match, p1, width, height) => {
                $('.bp-viewbox').val(`0 0 ${width} ${height}`);
                return `<svg${p1} viewBox="0 0 ${width} ${height}"`;
          });
          return new Blob([unescape(svgContent)], { type: "image/svg" });
        }
           
        const response = new Promise (function (resolve, reject) {
          let element = document.querySelector(".hidden-preview .bp-poster-preview");
          const isSafari = navigator.vendor && navigator.vendor.indexOf('Apple') > -1 &&
                  navigator.userAgent
                  && navigator.userAgent.indexOf('CriOS') == -1
                  && navigator.userAgent.indexOf('FxiOS') == -1
                  && !navigator.userAgent.match('FxiOS')
                  && navigator.userAgent.indexOf('OPT') == -1 ;

          if (isSafari) {          
            domtoimage.toSvg(element, { width: element.offsetWidth, height: element.offsetHeight }).then(dataUrl => { 
              // svgDataUrlToDirectBlob(dataUrl)
              // .then((blob) => {
              //   let file = new File([blob], 'preview.png', {type: blob.type});
              //   resolve(file);
              // })
              // .catch(() => {
              //   reject('');
              // });

              let blob = svgDataUrlToDirectBlob(dataUrl);
              let file = new File([blob], 'preview.svg', {type: blob.type});
              resolve(file);
              
              // svgDataUrlToBlob(dataUrl, (blob) => {
              //   let file = new File([blob], 'preview.jpg', {type: blob.type});
              //   resolve(file);
              // })
            })
            .catch(function (error) {
              console.error('oops, something went wrong!', error);
              reject('');
            });
          } else {
            domtoimage.toBlob(element, { width: element.offsetWidth, height: element.offsetHeight }).then(blob => {     
              let file = new File([blob], 'preview.jpg', {type: blob.type});   
              resolve(file);
            })
            .catch(function (error) {
              console.error('oops, something went wrong!', error);
              reject('');
            });
          }
        })
        return response;
      }
      imageLoaded(img) {
        return new Promise((resolve, reject) => {
            // Check if the image is already loaded
            if (img.complete && img.naturalHeight !== 0) {
                resolve();
            } else {
              // Set up event listeners to resolve or reject the promise
              img.addEventListener('load', () => resolve());
              img.addEventListener('error', () => reject(new Error('Failed to load image')));
            }
        });
      }
    }
  );
}
